import { AdsDescriptionProps } from '../../components/AdsDescription'
import { Classified } from '../../rest/types/Classified'
import { MediaType } from '../../form/fields/FormFieldUploadMedia'
import { isBase64ImageURL } from '../../helpers/FileHelpers'

import { ImageTransformer } from './ImageTransformer'

export function ClassifiedDescriptionTransformer({
  classified,
  t,
}: {
  classified: Classified
  t: any
}): AdsDescriptionProps | undefined {
  return classified
    ? {
        ...(classified?.mainMediaType === MediaType.Video &&
          classified?.videoUrl && {
            video: {
              light: '/static/assets/images/video_preview.jpg',
              url: classified?.videoUrl,
              controls: true,
            },
          }),
        ...(classified?.mainMediaType === MediaType.Photo &&
          classified?.image && {
            image: classified?.image
              ? isBase64ImageURL((classified.image as any).url)
                ? {
                    src: (classified.image as any).url,
                    width: (classified.image as any).width,
                    height: (classified.image as any).height,
                    alt: '',
                  }
                : ImageTransformer(classified?.image as any)
              : undefined,
          }),
        title: t('ads_description_title'),
        text: classified.description ?? ('' as any),
      }
    : undefined
}
